module.exports = __webpack_public_path__ + "img/右哼哼.a0a7d8be.gif";